
function PageFooter() {
    return(
        <>
        <footer className="page-footer">
            <div className="footer-content">
            <a href="/RESUME - LOOMIS.pdf" download="RESUME - LOOMIS.pdf">Resume</a>
            <a href="https://www.linkedin.com/in/tristian-loomis-4b2784223" target="_blank" rel="noopener noreferrer">Linkedin</a>
            <a href="https://github.com/Chichian2" target="_blank" rel="noopener noreferrer">Github</a>
            </div>
        </footer>
        </>
    )
}
export default PageFooter